import { Star, Quote, ArrowRight } from "lucide-react";

// PLACEHOLDER CONTENT — DO NOT SHIP IN PRODUCTION
// ───────────────────────────────────────────────
// The reviewers, guides, ratings and review counts in this file are
// illustrative-only placeholders. They were authored during development to
// demonstrate the layout. Render this component only behind DEMO_CONTENT
// in `data/business.ts`. Replace with real reviews (with the reviewers'
// permission) and real guide bios + photos before enabling.
const reviews = [
  {
    name: "Kayla R.", city: "Atlanta, GA", initials: "KR",
    source: "Google", url: "https://www.google.com/search?q=ocoee+river+experience+reviews",
    text: "Best 2 hours of our Atlanta trip. Our guide Marcus had us laughing the entire time and made first-timers feel safe through Hell Hole.",
  },
  {
    name: "Daniel P.", city: "Nashville, TN", initials: "DP",
    source: "TripAdvisor", url: "https://www.tripadvisor.com/Search?q=ocoee+river+experience",
    text: "Brought a corporate group of 22. Booking was simple, gear was clean, and the guides ran a tight, professional safety briefing. Will be back.",
  },
  {
    name: "Maria & Tom", city: "Knoxville, TN", initials: "MT",
    source: "Google", url: "https://www.google.com/search?q=ocoee+river+experience+reviews",
    text: "Stayed at the Lodge, ate at Sugarloaf, rafted the Olympic Upper. One-stop weekend. Already planning the next.",
  },
  {
    name: "Jordan H.", city: "Chattanooga, TN", initials: "JH",
    source: "Google", url: "https://www.google.com/search?q=ocoee+river+experience+reviews",
    text: "Took my teen daughters for their first whitewater run. Gear was sized right, briefing was clear, and the guides nailed the safety vs. fun balance.",
  },
  {
    name: "Sam K.", city: "Birmingham, AL", initials: "SK",
    source: "TripAdvisor", url: "https://www.tripadvisor.com/Search?q=ocoee+river+experience",
    text: "The Upper Olympic course is no joke — and that's exactly why I came. Travis read the water like a poet. Already booked next season.",
  },
];

// New round #46-47: each guide has a bio that adds personality, not just credentials.
const guides = [
  { name: "Marcus", initials: "M", role: "Lead Guide · ACA & USCG-licensed · 9 seasons",
    bio: "Started rafting the Ocoee at 17. Knows every eddy by name. Off the water, fly fishing." },
  { name: "Jenna",  initials: "J", role: "Trip Captain · Wilderness First Responder · 6 seasons",
    bio: "Former Olympic-course safety boater. The calm voice you want in Hell Hole." },
  { name: "Travis", initials: "T", role: "Upper Olympic specialist · Former TVA staff",
    bio: "Worked the TVA release schedule before guiding it. Reads water like nobody else." },
];

export function Testimonials() {
  return (
    <section className="trust-block" aria-label="Reviews and guides">
      <div className="trust-block-head">
        <span className="eye">REAL GUESTS · REAL GUIDES</span>
        {/* New round #45: rating phrased once, not twice */}
        <h2 className="h2">Stories from the river</h2>
        <div className="trust-stars" aria-label="4.9 out of 5 stars">
          <Star aria-hidden="true" /><Star aria-hidden="true" /><Star aria-hidden="true" /><Star aria-hidden="true" /><Star aria-hidden="true" />
          <span className="trust-stars-num">4.9 / 5</span>
          <span className="trust-stars-sub">· 1,200+ trips booked</span>
        </div>
        {/* New round #44: external trust badges */}
        <div className="trust-badges-strip">
          <a
            className="trust-strip-badge"
            href="https://www.tripadvisor.com/Search?q=ocoee+river+experience"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="trust-strip-badge-mark" aria-hidden="true">★</span>
            TripAdvisor · Travelers' Choice
          </a>
          <a
            className="trust-strip-badge"
            href="https://www.google.com/search?q=ocoee+river+experience+reviews"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="trust-strip-badge-mark" aria-hidden="true">G</span>
            Google · 4.9★ Rated
          </a>
        </div>
      </div>

      {/* New round #41: scrollable carousel of reviews */}
      <div className="reviews-grid" role="list">
        {reviews.map((r) => (
          <a
            key={r.name}
            role="listitem"
            href={r.url}
            target="_blank"
            rel="noopener noreferrer"
            className="review-card"
          >
            <Quote className="review-quote" aria-hidden="true" />
            <p className="review-text">{r.text}</p>
            <div className="review-meta">
              <span className="review-avatar" aria-hidden="true">{r.initials}</span>
              <div>
                <strong>{r.name}</strong>
                <span>{r.city} · {r.source} ★★★★★</span>
              </div>
            </div>
          </a>
        ))}
      </div>

      <div className="guides">
        <h3 className="h3">Meet a few of the guides on the water</h3>
        <ul className="guides-list">
          {guides.map((g) => (
            <li key={g.name}>
              <span className="guide-avatar" aria-hidden="true">
                {g.initials}
              </span>
              <div>
                <strong>{g.name}</strong>
                <span>{g.role}</span>
                {/* New round #47 */}
                <em>{g.bio}</em>
              </div>
            </li>
          ))}
        </ul>
        {/* New round #48: link to a future "Meet the team" page */}
        <a className="guides-link" href="/team">
          Meet the full crew <ArrowRight size={14} aria-hidden="true" />
        </a>
        <p className="guides-note">
          All guides carry CPR + First Aid certification. Our outfitter is
          licensed through the Tennessee Department of Tourist Development and
          permitted by the U.S. Forest Service for the Cherokee National Forest.
        </p>
      </div>
    </section>
  );
}
